<template>
  <section class="agenda daytwo">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Day 1 of Presentations
            </h1>
          </div>
        </div>
      </div>
      
      <daytwomorning/>
      <daytwolunch />
      <daytwoafternoon />
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda/daytwo.scss';
</style>

<script>
import daytwomorning from '@/components/agenda/day-two-morning.vue';
import daytwolunch from '@/components/agenda/day-two-lunch.vue';
import daytwoafternoon from '@/components/agenda/day-two-afternoon.vue';

export default {
  name: 'Day Two',
  components: {
    daytwomorning,
    daytwolunch,
    daytwoafternoon
  }
};
</script>